"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionReplace = exports.ActionMap = exports.ActionDrop = exports.IkeCollectionUpgradeActionFactory = void 0;
var __1 = require("..");
var select_list_field_1 = require("../fields/select.list.field");
var IkeCollectionUpgradeActionFactory = /** @class */ (function () {
    function IkeCollectionUpgradeActionFactory() {
    }
    IkeCollectionUpgradeActionFactory.createAction = function (action) {
        switch (action.action) {
            case 'map':
                return new ActionMap(action);
            case 'drop':
                return new ActionDrop(action);
            case 'replace':
                return new ActionReplace(action);
            default:
                throw new Error('Invalid action type ' + action['action']);
        }
    };
    return IkeCollectionUpgradeActionFactory;
}());
exports.IkeCollectionUpgradeActionFactory = IkeCollectionUpgradeActionFactory;
var ActionDrop = /** @class */ (function () {
    function ActionDrop(action) {
        this.reason = 'drop';
        this.targetFieldId = null;
        this.action = action;
    }
    ActionDrop.prototype.process = function (oldField, newField, log) {
        newField.Mutator.clear();
        return true;
    };
    return ActionDrop;
}());
exports.ActionDrop = ActionDrop;
var ActionMap = /** @class */ (function () {
    function ActionMap(action) {
        this.reason = 'map';
        this.requiresTargetField = true;
        this.action = action;
        this.targetFieldId = action.targetFieldId;
    }
    return ActionMap;
}());
exports.ActionMap = ActionMap;
var ActionReplace = /** @class */ (function () {
    function ActionReplace(action) {
        this.reason = 'replace';
        this.requiresTargetField = true;
        this.action = action;
        this.targetFieldId = action.targetFieldId;
    }
    ActionReplace.prototype.process = function (oldField, newField, log) {
        // The values already aligned no need to transform
        if (oldField.displayValue === newField.displayValue) {
            return true;
        }
        if (__1.CollectionModelFieldNestedList.isNestedListField(oldField) && __1.CollectionModelFieldNestedList.isNestedListField(newField)) {
            return this.processNestedList(oldField, newField, log);
        }
        if (select_list_field_1.CollectionModelFieldSelectList.isSelectListField(oldField) && select_list_field_1.CollectionModelFieldSelectList.isSelectListField(newField)) {
            return this.processSelectList(oldField, newField, log);
        }
        log.error({ fieldType: newField.schema.type }, "ActionReplace: Unsupported field type for replace '".concat(newField.schema.type, "'"));
        return false;
    };
    ActionReplace.prototype.processNestedList = function (oldField, newField, log) {
        var newValue = this.action.values[oldField.displayValue];
        if (!Array.isArray(newValue)) {
            return false;
        }
        // Unset field
        if (newValue.length === 0) {
            newField.Mutator.manual(null);
            log.info({ oldValue: oldField.displayValue }, "ActionReplace: Dropped value ".concat(__1.CollectionModelFieldNestedList.TYPE));
            return true;
        }
        newField.Mutator.manual(newValue);
        if (!newField.hasValue()) {
            log.error({ oldValue: oldField.displayValue, newValue: newValue.join(' > ') }, "ActionReplace: Failed to find match for ".concat(__1.CollectionModelFieldNestedList.TYPE));
            return false;
        }
        return true;
    };
    ActionReplace.prototype.processSelectList = function (oldField, newField, log) {
        var newValue = this.action.values[oldField.displayValue];
        if (typeof newValue !== 'string') {
            return false;
        }
        // Unset field
        if (newValue.length === 0) {
            newField.Mutator.manual(null);
            log.info({ oldValue: oldField.displayValue }, "ActionReplace: Dropped value ".concat(__1.CollectionModelFieldNestedList.TYPE));
            return true;
        }
        newField.Mutator.manual(newValue);
        if (!newField.hasValue()) {
            log.error({ oldValue: oldField.displayValue, newValue: newValue }, "ActionReplace: Failed to find match for ".concat(select_list_field_1.CollectionModelFieldSelectList.TYPE));
            return false;
        }
        return true;
    };
    return ActionReplace;
}());
exports.ActionReplace = ActionReplace;
//# sourceMappingURL=collection.upgrade.action.js.map